const ClientNotes = (app) => {
  app.post(
    "/client-notes/create",
    async ({ api, flash, req, res, locals }) => {
      const { body, query = {} } = req;
      const { proxyAthlete } = query;

      try {
        const noteBody = {
          userId: body.userId,
          coachId: locals.activeUserToRequest._id,
          title: body.title || "",
          content: typeof body.content === "string"
            ? JSON.parse(body.content)
            : body.content,
        };

        await api(`client-notes?proxyAthlete=${proxyAthlete}`, {
          method: "POST",
          body: noteBody,
        });

        flash("success", "Note successfully created");

        res.refreshWith(
          { modal: "" },
          { url: "back", hash: "#_" }
        );
      } catch (error) {
        flash("error", error.message);

        res.refreshWith(
          { "modal[type]": "create-note" },
          { url: "back", hash: "#_" }
        );
      }
    }
  );

  app.post(
    "/client-notes/update",
    async ({ api, flash, req, res }) => {
      const { body, query = {} } = req;
      const { proxyAthlete } = query;

      const stayInViewNote =
        body.stayInViewNote === "true" || body.stayInViewNote === true;

      try {
        const content =
          typeof body.content === "string"
            ? JSON.parse(body.content)
            : body.content;

        await api(`client-notes/${body.noteId}?proxyAthlete=${proxyAthlete}`, {
          method: "PUT",
          body: {
            title: body.title || "",
            content,
          },
        });

        flash("success", "Note successfully updated");

        if (stayInViewNote) {
          res.refreshWith(
            { "modal[type]": "view-note", noteId: body.noteId },
            { url: "back", hash: "#_" }
          );
        } else {
          res.refreshWith(
            { modal: "", noteId: "" },
            { url: "back", hash: "#_" }
          );
        }
      } catch (error) {
        flash("error", error.message);

        if (stayInViewNote) {
          res.refreshWith(
            { "modal[type]": "view-note", noteId: body.noteId },
            { url: "back", hash: "#_" }
          );
        } else {
          res.refreshWith(
            {
              "modal[type]": "create-note",
              noteId: body.noteId,
            },
            { url: "back", hash: "#_" }
          );
        }
      }
    }
  );

  app.post(
    "/client-notes/toggle-pin",
    async ({ api, flash, req, res }) => {
      const { body, query = {} } = req;
      const { proxyAthlete } = query;

      try {
        await api(
          `client-notes/${body.noteId}?proxyAthlete=${proxyAthlete}`,
          {
            method: "PUT",
            body: { isPinned: body.isPinned === "true" || body.isPinned === true },
          }
        );

        flash("success", body.isPinned === "true" || body.isPinned === true
          ? "Note pinned"
          : "Note unpinned"
        );

        res.refreshWith({}, { url: "back", hash: "#_" });
      } catch (error) {
        flash("error", error.message);
        res.refreshWith({}, { url: "back", hash: "#_" });
      }
    }
  );

  app.post(
    "/client-notes/delete",
    async ({ api, flash, req, res }) => {
      const { body, query = {} } = req;
      const { proxyAthlete } = query;

      let noteIds = body.noteIds;
      if (typeof noteIds === "string") {
        try {
          noteIds = JSON.parse(noteIds);
        } catch {
          noteIds = [];
        }
      }
      if (!Array.isArray(noteIds) || !noteIds.length) {
        flash("error", "No notes selected");
        return res.refreshWith({}, { url: "back", hash: "#_" });
      }

      try {
        await Promise.all(
          noteIds.map((noteId) =>
            api(`client-notes/${noteId}?proxyAthlete=${proxyAthlete}`, {
              method: "DELETE",
            })
          )
        );

        flash(
          "success",
          noteIds.length === 1
            ? "Note deleted"
            : `${noteIds.length} notes deleted`
        );

        res.refreshWith({}, { url: "back", hash: "#_" });
      } catch (error) {
        flash("error", error.message);
        res.refreshWith({}, { url: "back", hash: "#_" });
      }
    }
  );
};

export default ClientNotes;
